module.exports = [
	{
		"match": "graphics",
		"title": "Customize your graphics",
		"content": "Have an Envato Studio expert customize your graphics, starting from&nbsp;$20.",
		"button_label": "Customize Now",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/customize-graphics?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=CustomizeGraphics"
	},
	{
		"match": "print-templates/newsletters",
		"title": "Get your copy right",
		"content": "Hire a professional Copywriter on Envato Studio to create engaging content to share with your&nbsp;customers.",
		"button_label": "Find Copywriters",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/copywriting?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=GetYourCopyRight"
	},
	{
		"match": "print-templates/stationery/resumes",
		"title": "Improve your resume",
		"content": "Hire an expert Copywriter on Envato Studio to craft the perfect resume for&nbsp;you.",
		"button_label": "Find Copywriters",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/resumes-cover-letters?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=ImproveYourResume"
	},
	{
		"match": "logo-templates",
		"title": "Animate your logo",
		"content": "Have an Envato Studio expert animate your logo and bring your brand to&nbsp;life.",
		"button_label": "Get Animated",
		"icon_source": "envato-studio.png",
		"link": "https://studio.envato.com/explore/logo-animation?utm_source=EnvatoMarket&utm_medium=graphicriver&utm_campaign=sidebar&utm_content=AnimateYourLogo"
	},
	{
		"match": "graphics/3d-renders",
		"title": "Need 3D Models?",
		"content": "If you need more than the layered 3D renders we sell right here, check out the thousands of <a href=\"https://3docean.net/category/3d-models\">stock 3D models</a> on our sister site, <a href=\"https://3docean.net/\">3dOcean</a>. ",
		"button_label": "Browse 3D Models",
		"icon_source": "3d.png",
		"link": "https://3docean.net/category/3d-models"
	},
	{
		"match": "presentation-templates",
		"title": "Hello World",
		"content": "If you want your <a href=\"https://graphicriver.net/category/presentation-templates/keynote-templates\">Keynote</a> or <a href=\"https://graphicriver.net/category/presentation-templates/powerpoint-templates\">Powerpoint presentation templates</a> to really stand out, you need the <a href=\"https://audiojungle.net/category/music\">right music</a>, which you can find on <a href=\"https://audiojungle.net\">AudioJungle</a>.",
		"button_label": "Browse Stock Music",
		"icon_source": "audio_v2.png",
		"link": "https://audiojungle.net/category/logos-idents"
	},
	{
		"match": "web-elements",
		"title": "Full CSS",
		"content": "If rather than just buying the web element graphics, you'd prefer it to be fully functional, be sure to check out the CSS category on CodeCanyon.",
		"button_label": "Browse CSS",
		"icon_source": "code_2.png",
		"link": "https://codecanyon.net/category/css"
	}
];


//////////////////
// WEBPACK FOOTER
// ./config/sites/ads/graphicriver.json
// module id = 467
// module chunks = 1